module.exports = __webpack_public_path__ + "static/media/feature-evaluations.c4d70d83.png";